import { bottomAction, CONV_STORAGE, kinoControls, kinoParticipants, muteParticipants, onStage, room, socket, unMuteMic, Video } from "../../libs/roomnew";
import kinoTooltip from "../../room/kinoTooltip";
import { logError, notifyUser } from '../../utils/errorHandler';

export default class MuteAllState{
    constructor(){
        this.muteChecked=false;
        // this.muteIcon = `<svg width="48px" height="48px" viewBox="0 0 48 48"><g id="mic-muted"><path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="none" stroke="none"></path><path d="M18 20C18 23.3 15.3 26 12 26L6 26C2.7 26 0 23.3 0 20L0 6C0 2.7 2.7 0 6 0L12 0C15.3 0 18 2.7 18 6L18 20L18 20Z" transform="translate(15 4)" id="Shape" fill="#d6dadb" stroke="none"></path><path d="M0 0L4 0L4 10L0 10L0 0Z" transform="translate(22 34)" id="Shape" fill="#d6dadb" stroke="none"></path><path d="M22 2C22 2 16 0 11 0C6 0 0 2 0 2L0 4L22 4L22 2L22 2Z" transform="translate(13 41)" id="Shape" fill="#d6dadb" stroke="none"></path><path d="M0 0L8 0L8 2L0 2L0 0ZM18 0L10 0L10 2L18 2L18 0ZM8 4L0 4L0 6L8 6L8 4ZM10 4L18 4L18 6L10 6L10 4ZM8 8L0 8L0 10L8 10L8 8ZM10 8L18 8L18 10L10 10L10 8ZM0 12L8 12L8 14L0 14L0 12ZM18 12L10 12L10 14L18 14L18 12Z" transform="translate(15 10)" id="Shape" fill="#d6dadb" fill-rule="evenodd" stroke="none"></path><path d="M13 17L9 17C5.9 17 0 15.3 0 9L0 0L2 0L2 9C2 14.9 8.7 15 9 15L13 15C13.3 15 20 14.9 20 9L20 0L22 0L22 9C22 15.3 16.1 17 13 17L13 17Z" transform="translate(13 18)" id="Shape" fill="#d6dadb" stroke="none"></path><path d="M0 0L4 0L4 53.7L0 53.7L0 0Z" transform="matrix(0.7070944 -0.7071192 0.7071192 0.7070944 3.564331 6.393372)" id="Shape" fill="#78909c" stroke="none"></path></g></svg>`;
        this.muteIcon = `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36.0248 10.5057L36.5248 10.5118L36.531 10.0119L36.5462 8.78119C36.5922 5.05391 33.2572 2.08619 29.2229 2.03634C27.9174 2.0202 26.7566 2.23445 25.7825 2.6724C25.8201 2.63803 25.8581 2.60407 25.8965 2.5705C27.3419 1.30717 29.4306 0.577254 32.0032 0.609047C37.1208 0.672292 41.1254 4.40932 41.0707 8.83711L41.0555 10.0678L41.0493 10.5677L41.5493 10.5739L42.9989 10.5918L38.7407 14.2929L34.5752 10.4877L36.0248 10.5057Z" fill="#032836" stroke="#78909C"/>
        <path d="M33 24C33 27.3 30.3 30 27 30H21C17.7 30 15 27.3 15 24V10C15 6.7 17.7 4 21 4H27C30.3 4 33 6.7 33 10V24Z" fill="#032836"/>
        <path d="M22 34H26V44H22V34Z" fill="#78909C"/>
        <path d="M35 43C35 43 29 41 24 41C19 41 13 43 13 43V45H35V43Z" fill="#032836"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10H23V12H15V10ZM33 10H25V12H33V10ZM23 14H15V16H23V14ZM25 14H33V16H25V14ZM23 18H15V20H23V18ZM25 18H33V20H25V18ZM15 22H23V24H15V22ZM33 22H25V24H33V22Z" fill="#78909C"/>
        <path d="M26 35H22C18.9 35 13 33.3 13 27V18H15V27C15 32.9 21.7 33 22 33H26C26.3 33 33 32.9 33 27V18H35V27C35 33.3 29.1 35 26 35Z" fill="#032836"/>
        <path d="M3.56433 6.39337L6.39271 3.56489L44.365 41.5359L41.5366 44.3643L3.56433 6.39337Z" fill="#78909C"/>
        </svg>
        `;
        this.muteLockIcon=`<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_9_2)">
        <path d="M33 24C33 27.3 30.3 30 27 30H21C17.7 30 15 27.3 15 24V10C15 6.7 17.7 4 21 4H27C30.3 4 33 6.7 33 10V24Z" fill="#032836"/>
        <path d="M22 34H26V44H22V34Z" fill="#78909C"/>
        <path d="M35 43C35 43 29 41 24 41C19 41 13 43 13 43V45H35V43Z" fill="#032836"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10H23V12H15V10ZM33 10H25V12H33V10ZM23 14H15V16H23V14ZM25 14H33V16H25V14ZM23 18H15V20H23V18ZM25 18H33V20H25V18ZM15 22H23V24H15V22ZM33 22H25V24H33V22Z" fill="#78909C"/>
        <path d="M26 35H22C18.9 35 13 33.3 13 27V18H15V27C15 32.9 21.7 33 22 33H26C26.3 33 33 32.9 33 27V18H35V27C35 33.3 29.1 35 26 35Z" fill="#032836"/>
        <path d="M3.56433 6.39337L6.39271 3.56489L44.365 41.5359L41.5366 44.3643L3.56433 6.39337Z" fill="#78909C"/>
        <g filter="url(#filter0_d_9_2)">
        <path d="M41.6359 9.99585H26.3641C25.0584 9.99585 24 11.0541 24 12.3594V23.629C24 24.9344 25.0584 25.9926 26.3641 25.9926H41.6359C42.9416 25.9926 44 24.9344 44 23.629V12.3594C44 11.0541 42.9416 9.99585 41.6359 9.99585ZM35.0225 18.1998C35.0415 18.2787 35.0518 18.3609 35.0518 18.4454V20.4671C35.0518 21.0492 34.5754 21.5255 33.9932 21.5255C33.411 21.5255 32.9346 21.0492 32.9346 20.4671V18.4454C32.9346 18.3584 32.9455 18.2738 32.9655 18.1928C32.3819 17.8414 31.9914 17.2019 31.9914 16.4711C31.9914 15.362 32.8907 14.463 34 14.463C35.1093 14.463 36.0086 15.362 36.0086 16.4711C36.0086 17.2069 35.6128 17.85 35.0225 18.1998Z" fill="#032836"/>
        <path d="M36.3637 0.397354C35.6084 0.122661 34.836 -0.0012095 34.0532 8.8977e-06C33.2703 -0.0012095 32.3915 0.122661 31.6363 0.397354C28.1173 1.67728 26.8391 4.83575 27.0152 9.0169H29.9364C29.7724 6.13566 30.517 4.19419 32.3368 3.3649C33.3912 2.88446 34.6088 2.88446 35.6631 3.3649C37.483 4.19417 38.2275 6.13564 38.0635 9.0169H40.9848C41.1609 4.83575 39.8827 1.67728 36.3637 0.397354Z" fill="#032836"/>
        </g>
        </g>
        <defs>
        <filter id="filter0_d_9_2" x="18" y="-4" width="30" height="35.9926" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-1" dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9_2"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9_2" result="shape"/>
        </filter>
        <clipPath id="clip0_9_2">
        <rect width="48" height="48" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        `;

        this.muteLockNotificationIcon=`<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_9_2)">
        <path d="M33 24C33 27.3 30.3 30 27 30H21C17.7 30 15 27.3 15 24V10C15 6.7 17.7 4 21 4H27C30.3 4 33 6.7 33 10V24Z" fill="#CFD8DC"/>
        <path d="M22 34H26V44H22V34Z" fill="#78909C"/>
        <path d="M35 43C35 43 29 41 24 41C19 41 13 43 13 43V45H35V43Z" fill="#CFD8DC"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15 10H23V12H15V10ZM33 10H25V12H33V10ZM23 14H15V16H23V14ZM25 14H33V16H25V14ZM23 18H15V20H23V18ZM25 18H33V20H25V18ZM15 22H23V24H15V22ZM33 22H25V24H33V22Z" fill="#78909C"/>
        <path d="M26 35H22C18.9 35 13 33.3 13 27V18H15V27C15 32.9 21.7 33 22 33H26C26.3 33 33 32.9 33 27V18H35V27C35 33.3 29.1 35 26 35Z" fill="#CFD8DC"/>
        <path d="M3.56433 6.39337L6.39271 3.56489L44.365 41.5359L41.5366 44.3643L3.56433 6.39337Z" fill="#78909C"/>
        <g filter="url(#filter0_d_9_2)">
        <path d="M41.6359 9.99585H26.3641C25.0584 9.99585 24 11.0541 24 12.3594V23.629C24 24.9344 25.0584 25.9926 26.3641 25.9926H41.6359C42.9416 25.9926 44 24.9344 44 23.629V12.3594C44 11.0541 42.9416 9.99585 41.6359 9.99585ZM35.0225 18.1998C35.0415 18.2787 35.0518 18.3609 35.0518 18.4454V20.4671C35.0518 21.0492 34.5754 21.5255 33.9932 21.5255C33.411 21.5255 32.9346 21.0492 32.9346 20.4671V18.4454C32.9346 18.3584 32.9455 18.2738 32.9655 18.1928C32.3819 17.8414 31.9914 17.2019 31.9914 16.4711C31.9914 15.362 32.8907 14.463 34 14.463C35.1093 14.463 36.0086 15.362 36.0086 16.4711C36.0086 17.2069 35.6128 17.85 35.0225 18.1998Z" fill="#78909C"/>
        <path d="M36.3637 0.397354C35.6084 0.122661 34.836 -0.0012095 34.0532 8.8977e-06C33.2703 -0.0012095 32.3915 0.122661 31.6363 0.397354C28.1173 1.67728 26.8391 4.83575 27.0152 9.0169H29.9364C29.7724 6.13566 30.517 4.19419 32.3368 3.3649C33.3912 2.88446 34.6088 2.88446 35.6631 3.3649C37.483 4.19417 38.2275 6.13564 38.0635 9.0169H40.9848C41.1609 4.83575 39.8827 1.67728 36.3637 0.397354Z" fill="#78909C"/>
        </g>
        </g>
        <defs>
        <filter id="filter0_d_9_2" x="18" y="-4" width="30" height="35.9926" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-1" dy="1"/>
        <feGaussianBlur stdDeviation="2.5"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9_2"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9_2" result="shape"/>
        </filter>
        <clipPath id="clip0_9_2">
        <rect width="48" height="48" fill="white"/>
        </clipPath>
        </defs>
        </svg>
`;
        this.muteStateText="";
        this.muteLocked=false;
        this.unmuteAllowedByRequest=false;
        this.unmuteAllowedTimeout=0;
        this.unmuteRequest;
    }

    events(){
        let m=this;
        socket.events.MuteLock=this.onMuteLocked.bind(m);
        socket.events.MuteUnlock=this.onMuteUnlocked.bind(m);
        socket.events.MuteUnlockRequest=this.onMuteUnlockRequest.bind(m);
        socket.events.MuteUnlockResponse=this.onMuteUnlockResponse.bind(m);
        socket.events.MuteUnlockRequestCancel=this.onMuteUlockRequestCancel.bind(m);
    }

    isMuteEnabled(){
        return this.muteChecked;
    };
    isMuteLocked(){
        return this.muteLocked;
    }
    addControlButton(){
        kinoControls.registerControl('mute-on-join',this.muteIcon,'Everyone joins muted',"switch",false,(el)=>{
            this.setMuteAllState(!this.isMuteEnabled());
        });
        kinoControls.registerControl('mute-lock',this.muteLockIcon,'Mute lock',"switch",false,(el)=>{
            this.setMuteLocked(!this.isMuteLocked());
        });
    }

    setMuteLocked(locked){
        if(this.muteLocked==locked){return};
        this.muteLocked=locked;
        if(locked){
            try {
                muteParticipants.muteAll();
            } catch (error) { logError(error, 'muteAll'); notifyUser('Failed to mute participants.'); }
            this.sendMuteLockMessage();
        }else{
            this.sendMuteUnlockMessage();
        }
    }
    isMod(){
        return HOST == 1 || ROLE == "moderator";
    };
    onMuteLocked(message,fromLocal=false){
        console.log("mute locked message",message);
        if(fromLocal){
            kinoControls.toggleSwitch('mute-lock',true);
        }else{
            // if(message.space_id==CONV_STORAGE.myConversation || (!message.space_id && !CONV_STORAGE.myConversation)){
            //     let p=kinoParticipants.get(message.from_id);
            //     if(p){
            //         let notificationText=`Microphone`;
            //         Video.showNotification(this.muteLockNotificationIcon,notificationText,'mute-lock',message.from_id);
            //     }
            // }
        }

    };

    onMuteUnlocked(message,fromLocal=false){
        // this.muteLocked=false;
        if(fromLocal){
            kinoControls.toggleSwitch('mute-lock',false);
        }
    }

    onMuteUnlockRequest(message){
        if(!this.isMod()){return}
        let p=kinoParticipants.get(message.from_id);
        if(p){
            let notificationText=`${p.getName()} is requesting to unmute their microphone`;
            Video.showNotification(muteParticipants.muteWhiteIcon,notificationText,'unmute-request',message.from_id,()=>{
                this.sendMuteUnlockResponse(message.from_id,message.from_socket_id,'allowed');
            });
        }
    };
    onMuteUlockRequestCancel(message){
        $(`#unmute-request-${message.from_id}`).remove();
    };

    setUnmuteAllowedTimeout(){
        this.unmuteAllowedByRequest=true;
        this.unmuteAllowedTimeout=setTimeout(() => {
            this.unmuteAllowedByRequest=false;
        }, 15000);
    };
    onMuteUnlockResponse(message){
        if(message.response=="allowed"){
            let notificationText=`Your unmute request was accepted, you can now unmute`;
            this.hideTooltip();
            this.showRequestAcceptedTooltip();
            this.setUnmuteAllowedTimeout();
        }
    };
    sendMuteLockMessage(){
        let message={
            eventName: 'MuteLock',
            from_id: room.myUserId(),
            space_id: CONV_STORAGE.myConversation
        };
        socket.emit(message);
        this.onMuteLocked(message,true);
        try {
            if(!this.muteChecked){
                this.setMuteAllState(true);
            }else{
                room.setLocalParticipantProperty('mute_all_policy', JSON.stringify({
                    mute:true,
                    mute_locked:true
                }));
            }

        } catch (error) { console.error("[Kino Error] [MuteAllState]", error); }
    };

    sendMuteUnlockMessage(){
        let message={
            eventName: 'MuteUnlock',
            from_id: room.myUserId(),
            space_id: CONV_STORAGE.myConversation
        };
        socket.emit(message);
        this.onMuteUnlocked(message,true);
        try {
            if(this.muteChecked){
                room.setLocalParticipantProperty('mute_all_policy', JSON.stringify({
                    mute:true,
                    mute_locked:false
                }));
            }else{
                room.setLocalParticipantProperty('mute_all_policy','');
            }
        } catch (error) { console.error("[Kino Error] [MuteAllState]", error); }
    };

    sendMuteUnlockRequest(){
        socket.emit({
            eventName:'MuteUnlockRequest',
            from_id: room.myUserId(),
            space_id: CONV_STORAGE.myConversation
        });
    };

    sendMuteUnlockRequestCancel(){
        socket.emit({
            eventName:'MuteUnlockRequestCancel',
            from_id: room.myUserId(),
        });
    };

    sendMuteUnlockResponse(from_pid,to_socket_id,response){
        socket.emit({
            eventName:'MuteUnlockResponse',
            from_id: room.myUserId(),
            from_pid:from_pid,
            to_socket_id:to_socket_id,
            response:response
        });
    };

    createUnmuteRequest(timeoutseconds=15,btn,cancel,text){
        this.unmuteRequest={
            timeout:setTimeout(() => {
                this.onRequestTimedOut(true);
                if(btn){
                    text.html('Microphones are locked by the moderators. Request to unmute.');
                    cancel.addClass('kino-btn-secondary').removeClass('btn-primary kino-btn-primary')
                    btn.removeClass('d-none');
                }
            }, 1000 * timeoutseconds)
        };
        this.sendMuteUnlockRequest();
    };

    cancelUnmuteRequest(){
        if(this.unmuteRequest){
            clearTimeout(this.unmuteRequest.timeout);
            this.unmuteRequest=undefined;
            this.sendMuteUnlockRequestCancel()
        }
    };

    onRequestTimedOut(notify=false){
        if(this.unmuteRequest){
            clearTimeout(this.unmuteRequest.timeout);
        }
        this.unmuteRequest=undefined;
        if(notify){
            //show a notification
        }

    };

    setMicAsLocked(){

    };

    setMicAsUnlocked(){

    };
    isUnmuteAllowed(){
        if(!this.isMod() && this.isUnmuteLocked() && !this.unmuteAllowedByRequest && !onStage.myStage.isStageView()){
            return false;
        }else{
            return true;
        }
    };

    showMuteLockedTooltip(){
        let requestUnmuteButton=$("<button/>",{
            class:'btn btn-primary kino-btn-primary btn-sm',
            html: `${this.unmuteRequest ? 'Cancel' : 'Request'}`
        }).on('click',(e)=>{
            e.stopPropagation();
            e.preventDefault();
            if(!this.unmuteRequest){
                this.createUnmuteRequest(17,requestUnmuteButton,requestcancel,muteLockedText);
                requestUnmuteButton.addClass(`d-none`)
                requestcancel.removeClass('kino-btn-secondary').addClass('btn-primary kino-btn-primary')
                muteLockedText.html('The request has been sent to the moderators.');
            }
        });
        let requestcancel=$("<button/>",{
            class:'btn kino-btn-secondary btn-sm',
            html:'Cancel'
        }).on('click',(e)=>{
            e.stopPropagation();
            e.preventDefault();
            if(this.unmuteRequest){
                this.cancelUnmuteRequest();
                muteLockedText.html('Microphones are locked by the moderators. Request to unmute.');
                requestcancel.addClass('kino-btn-secondary').removeClass('btn-primary kino-btn-primary')
                requestUnmuteButton.removeClass('d-none');
            }else{
                this.muteLockedtooltip.hideTooltip();
            }
        });

        let actionButtonsContainer=$("<div/>",{
                class:'mute-lock-tooltip-buttons',
                html:[requestcancel,requestUnmuteButton]
        });
        let muteLockedText=$('<span/>',{
            html:'Microphones are locked by the moderators. Request to unmute.'
        });
        let tooltipTitle=$('<span/>',{
            class:'tooltip-title',
            html:[muteParticipants.muteIcon,'Unmute request']
        })
        let tooltipContent=$("<div/>",{
            class:'mute-locked-tooltip-content',
            html:[tooltipTitle,muteLockedText,actionButtonsContainer]
        });
        $(".mute-locked-tooltip").remove();
        if(this.muteLockedtooltip){
            this.muteLockedtooltip.destroy();
            this.muteLockedtooltip=undefined;
        }
        this.muteLockedtooltip = new kinoTooltip("toolbox-mic-container",tooltipContent, {
            left: '-154px',
            bottom: '120%',
            width:'380px',
            autohideSeconds:300,
            customClass:'align-center mute-locked-tooltip'
        });
        this.muteLockedtooltip.addTooltip();
    };

    showRequestAcceptedTooltip(){
        let muteLockedText=$('<span/>',{
            html:'Your unmute request has been accepted. You can now unmute.'
        });
        let tooltipTitle=$('<span/>',{
            class:'tooltip-title',
            html:[muteParticipants.muteIcon,'Unmute request']
        })
        let innerContent=$("<div/>",{
            class:'tooltip-inner-content',
            html:[muteLockedText]
        })
        let tooltipContent=$("<div/>",{
            class:'mute-locked-tooltip-content',
            html:[tooltipTitle,innerContent]
        });
        $(".mute-locked-tooltip").remove();
        if(this.muteLockedtooltip){
            this.muteLockedtooltip.destroy();
            this.muteLockedtooltip=undefined;
        }
        this.muteLockedtooltip = new kinoTooltip("toolbox-mic-container",tooltipContent, {
            left: '-179px',
            bottom: '120%',
            width:'430px',
            autohideSeconds:15,
            customClass:'align-center mute-locked-tooltip request-accepted'
        });
        this.muteLockedtooltip.addTooltip();
    };

    hideTooltip(){
        if(this.muteLockedtooltip){
            this.muteLockedtooltip.destroy();
            this.muteLockedtooltip=undefined;
        } 
    }

    setMuteAllState(enabled){
        if(this.muteChecked === enabled){return}
        this.muteChecked=enabled;
        console.log("enabled is ",enabled);
        if(enabled){
            this.enableMuteAllState();
        }else{
            this.disableMuteAllState();
        }
    };


    enableMuteAllState(){
        if(!muteParticipants.isModerator()){return}
            // $('#mute-all-checkbox').prop("checked", true);
            kinoControls.toggleSwitch('mute-on-join',true);
            room.setLocalParticipantProperty('mute_all_policy', JSON.stringify({
                mute:true,
                mute_locked:this.muteLocked
            }));
    };

    disableMuteAllState(){
            // if(!muteParticipants.isModerator()){return}
            // $('#mute-all-checkbox').prop("checked", false);
            this.muteLocked=false;
            this.onMuteUnlocked('',true);
            kinoControls.toggleSwitch('mute-on-join',false);
            room.setLocalParticipantProperty('mute_all_policy', '');
    };

    //checks if at least one moderator has mute all option enabled for current space
    checkMuteAllPolicy(withCallback=false){
        try {
            if(this.isMod()){return}
            let pids=[];
            if(!CONV_STORAGE.myConversation){
                pids=kinoParticipants.getLobby().filter(p=>!p.local).map(p=>p.id);
            }else{
                pids=kinoParticipants.inMySpace();
            }
            console.log(`Participant ids in my space (${CONV_STORAGE.myConversation}) are `,pids);
            if(pids.length){
                for (let index = 0; index < pids.length; index++) {
                    const pid = pids[index];
                    if(room.getParticipantById(pid)){
                        let hasPolicy=room.getParticipantById(pid).getProperty('mute_all_policy');
                        if(hasPolicy){
                            if(withCallback){
                                withCallback(true);
                            }else{
                                muteParticipants.setMicMuted(pid);
                                let muteState=JSON.parse(hasPolicy);
                                if(muteState.mute_locked){
                                }
                            }
                            return;
                        }
                    }
                }
            }
            
        } catch (error) {
            console.error("check mute all policy error", error);
        }
    }

    isUnmuteLocked(){
        try {
            let pids=[];
            if(!CONV_STORAGE.myConversation){
                pids=kinoParticipants.getLobby().filter(p=>!p.local).map(p=>p.id);
            }else{
                pids=kinoParticipants.inMySpace();
            }
            console.log(`Participant ids in my space (${CONV_STORAGE.myConversation}) are `,pids);
            if(pids.length){
                for (let index = 0; index < pids.length; index++) {
                    const pid = pids[index];
                    if(room.getParticipantById(pid)){
                        let hasPolicy=room.getParticipantById(pid).getProperty('mute_all_policy');
                        if(hasPolicy){
                            let muteState=JSON.parse(hasPolicy);
                            if(muteState.mute_locked){
                                return true;
                            }
                            // muteParticipants.setMicMuted(room.getParticipantById(pid));
                            // return;
                        }
                    }
                }
                return false;
            }else{
                return false
            }
            
        } catch (error) {
            console.error("check mute all policy error", error);
            return false;
        }
    };

    onMuteStateChanged(user,newState){
        // let pid=user.getId();
        // let p=kinoParticipants.get(pid);
        // if(p){
        //     let pspace=p.getSpaceId();
        //     if(pspace==CONV_STORAGE.myConversation || (!CONV_STORAGE.myConversation && !pspace)){
                //we are in same space
                if(!this.isUnmuteLocked()){
                    this.hideTooltip();
                }
            // }
        // }
    }

    onUserSpaceChanged(){
        try {
            console.log("On user space changed");
           this.hideTooltip();
            this.unmuteAllowedByRequest=false;
            clearTimeout(this.unmuteAllowedTimeout);
            if(this.unmuteRequest){
                clearTimeout(this.unmuteRequest.timeout);
                this.unmuteRequest=undefined;
            } 
        } catch (error) {
            console.error(error);
        }
        
    };
};
